import React, { Component } from "react";
import PropTypes from "prop-types";

class InView extends Component {
    static propTypes = {
        onInView: PropTypes.func.isRequired,
        children: PropTypes.node,
        threshold: PropTypes.number, // optional threshold for visibility
    };

    static defaultProps = {
        threshold: .5,
    };

    componentDidMount() {
        if (!this.node) return;

        // IntersectionObserver if available
        if ("IntersectionObserver" in window) {
            this.observer = new IntersectionObserver(
                function (entries, observer) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            if (this.props.onInView) {
                                this.props.onInView();
                            }
                            observer.disconnect(); // only fire once
                        }
                    }.bind(this));
                }.bind(this),
                {
                    root: null,
                    threshold: this.props.threshold,
                }
            );

            this.observer.observe(this.node);
        } else {
            // fallback for older browsers: scroll listener
            this.handleScroll = this.handleScroll.bind(this);
            window.addEventListener("scroll", this.handleScroll);
            this.handleScroll(); // initial check
        }
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.handleScroll) {
            window.removeEventListener("scroll", this.handleScroll);
        }
    }

    handleScroll() {
        if (!this.node) return;
        const rect = this.node.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
            if (this.props.onInView) {
                this.props.onInView();
            }
            window.removeEventListener("scroll", this.handleScroll);
        }
    }

    render() {
        return (
            <div
                ref={function (el) {
                    this.node = el;
                }.bind(this)}
            >
                {this.props.children}
            </div>
        );
    }
}

export default InView;



// WEBPACK FOOTER //
// ./src/pages/common/InView.js